export default __webpack_public_path__ + "static/media/i01c.20017f94.png";